import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import {HeaderSkeleton, RadioItemSkeleton} from '.';
// import {makeStyles} from '@material-ui/core';

export interface RadioGroupSkeletonProps<T extends []> {
    className?: string;
    options?: T;
}

function RadioGroupSkeleton<T extends []>({
    className,
    options
}: React.PropsWithChildren<RadioGroupSkeletonProps<T>>) {
    return (
        <FormControl className={className} style={{width: '100%'}}>
            <FormLabel component="legend">
                <HeaderSkeleton height={30} />
            </FormLabel>
            <RadioGroup>
                {options ? (
                    options.map((option, i) => <RadioItemSkeleton key={i} />)
                ) : (
                    <>
                        <RadioItemSkeleton />
                        <RadioItemSkeleton />
                    </>
                )}
            </RadioGroup>
        </FormControl>
    );
}

export default RadioGroupSkeleton;
